import { EqlFieldsAutoComplete } from '@modules/common/components/EqlFieldsAutoComplete';
import { EMPTY_EQL_FIELD_VALUE } from '@modules/common/components/EqlFieldsAutoComplete/constants';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { ArrowDropDownRounded } from '@mui/icons-material';
import {
  AutocompleteRenderInputParams,
  Box,
  FilterOptionsState,
  InputAdornment,
  TextField,
} from '@mui/material';
import { EqlField } from 'generated/graphql';
import { capitalize } from 'lodash';
import { SyntheticEvent } from 'react';

interface MetadataFieldAutoCompleteProps {
  integrationSource: IntegrationSource;
  onChange: (_: SyntheticEvent, eqlField: EqlField) => void;
  value: EqlField | undefined;
  isLinked: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
}

export const MetadataFieldMappingAutoComplete = ({
  integrationSource,
  onChange,
  value,
  isLinked,
  isDisabled,
  isLoading,
}: MetadataFieldAutoCompleteProps) => {
  const labelName = integrationSource.namespace
    ? `${integrationSource.channel.displayName} - ${integrationSource.namespace}`
    : integrationSource.channel.displayName;

  const filterOptions = (
    options: EqlField[],
    state: FilterOptionsState<EqlField>,
  ) => {
    return options.filter((option) => {
      const isSourceAndTypeMatch =
        option.detail?.metadata?.source === integrationSource.source &&
        option.objectType.toString() ===
          integrationSource.integrationType.toString();

      const isSearchMatch = option.displayName
        .toLowerCase()
        .trim()
        .includes(state.inputValue.toLowerCase().trim());

      return isSourceAndTypeMatch && isSearchMatch;
    });
  };

  return (
    <Box width="17vw" minWidth="150px" maxWidth="350px">
      <EqlFieldsAutoComplete
        value={value ?? EMPTY_EQL_FIELD_VALUE}
        onChange={onChange}
        popupIcon={<ArrowDropDownRounded />}
        filterOptions={filterOptions}
        getOptionLabel={(option) => option.displayName}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <TextField
            {...params}
            sx={{
              fieldset: {
                borderColor: isLinked ? 'success.light' : undefined,
                borderWidth: isLinked ? '1.5px' : undefined,
              },
            }}
            label={`${capitalize(
              integrationSource.integrationType,
            )}: ${labelName}`}
            placeholder={isLoading ? 'Loading...' : 'Select'}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <Box
                    width="24px"
                    component="img"
                    alignSelf="center"
                    src={integrationSource.channel.logo}
                    alt={integrationSource.channel.displayName}
                  />
                </InputAdornment>
              ),
            }}
          />
        )}
        groupBy={() => ''}
        disabled={isDisabled || isLoading}
      />
    </Box>
  );
};
